import { productStore } from "@/store/ProductModule";
import { Variant } from "../models/product";
import { IncludedProducts, QuantityCalculationResultModel } from "../models/QuanityCalculatorCast";
import { CalculatorTypes } from "../enums/CalculatorTypes";

class CalculatorService {

    public GetVariants(selectedProductId: string = "", products: IncludedProducts[] = []) {
        if (selectedProductId !== "") {
            const newVariants: Variant[] = [];
            products
                .filter(x => x.ArticleNumber === selectedProductId)[0]
                .Variants.map(a => {
                    const variant: Variant = {
                        variantId: a.variantId, variantSystemId: "", variantName: a.variantName, category: "", url: "", productFacts: [], price: "", priceValue: 0,
                        currencyCode: "", showBuyButton: false, showQuantity: false, showPalletQuantity: false, variantAttributes: [],
                        itemPrimaryPackagingWeight: a.ItemPrimaryPackagingWeight, itemSecondaryPackagingContent: 0, isInFavouriteList: false, relatedProducts: [],
                        itemMaterialConsumption: a.ItemMaterialConsumption, itemConsumptionCalculatorBlock: a.ItemConsumptionCalculatorBlock,
                        itemConsumptionCalculator: a.ItemConsumptionCalculator, itemConsumptionCalculatorCast: a.ItemConsumptionCalculatorCast,
                        baseProductArticleNumber: selectedProductId, itemConsumptionCalculatorBag: a.ItemConsumptionCalculatorBag,
                        itemConsumptionCalculatorMortar: a.ItemConsumptionCalculatorMortar, itemConsumptionStringJoint: 0, itemConsumptionFullJoint: 0,
                        itemConsumptionCalculatorPlaster: a.ItemConsumptionCalculatorPlaster, itemConsumptionCalculatorFogSand: a.ItemConsumptionCalculatorFogSand,
                        itemConsumptionCalculatorSandBoxSand: a.ItemConsumptionCalculatorSandBoxSand,
                        itemConsumptionCalculatorUBlock: a.ItemConsumptionCalculatorUBlock,
                        insulationVariantModel: a.InsulationVariantModel,
                        itemAdditionalMaterialConsumption: a.ItemAdditionalMaterialConsumption,
                        itemFillingWithInsulation: a.ItemFillingWithInsulation,
                        fillingProductModel: a.FillingProductModel,
                        carbonSavingsModel: a.CarbonSavingsModel,
                        isBuyable: a.IsBuyable,
                        fogSandMultiplyingFactor: a.FogSandMultiplyingFactor,
                    };
                    newVariants.push(variant);
                });
            return newVariants as Variant[];
        } else {
            return productStore.variants;
        }
    }

    public GetVariant(selectedProductId: string = "", variants: Variant[] = [], calculatorType: string = "") {
        return selectedProductId !== ""
            ? variants.filter(
                  x =>
                      x.baseProductArticleNumber === selectedProductId &&
                      ((calculatorType === CalculatorTypes.Block && x.itemConsumptionCalculatorBlock) ||
                      (calculatorType === CalculatorTypes.Bag && (x.itemConsumptionCalculatorBag || x.itemConsumptionCalculatorPlaster)) ||
                      (calculatorType === CalculatorTypes.Cast && x.itemConsumptionCalculatorCast) ||
                      (calculatorType === CalculatorTypes.Mortar && x.itemConsumptionCalculatorMortar) ||
                      (calculatorType === CalculatorTypes.SandboxSand && x.itemConsumptionCalculatorSandBoxSand) ||
                      (calculatorType === CalculatorTypes.FogSand && x.itemConsumptionCalculatorFogSand))
              )[0]
            : productStore.variant;
    }

    public storeSession(
        key: string,
        value: QuantityCalculationResultModel[]
    ): void {
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    }

    public storeSessionQuantity(
        key: string,
        value: number
    ): void {
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    }

    public GetDefaultQuantityCalculatorResultModel() {
        return {
            variantId: "", sack: 0, selected: "false", itemPackagingWeight: NaN, volume: 0, selectedShape: "", yta: NaN, layerThickness: NaN,
            itemMaterialConsumption: NaN, variantJoint: "", width: NaN, length: NaN, depth: NaN, variantSystemId: "",
        };
    }

    public GetSelectedProductMaterialConsumption(products: IncludedProducts[] = [], selectedProductId: string = "") {
        const productArray = products.filter(
            x => x.ArticleNumber === selectedProductId
        );
        return productArray !== undefined && productArray.length > 0
            ? productArray[0].ProductMaterialConsumption
            : 0;
    }

    public GetSelectedProductUrl(products: IncludedProducts[] = [], selectedProductId: string = "") {
        const product = this.GetSelectedProduct(products, selectedProductId);
        return product ? product.Url : "";
    }

    public GetSelectedProduct(products: IncludedProducts[] = [], selectedProductId: string = "") {
        const productArray = products.filter(
            x => x.ArticleNumber === selectedProductId
        );
        return productArray !== undefined && productArray.length > 0
            ? productArray[0]
            : undefined;
    }

    public GetCarbonSavingsModel(products: IncludedProducts[] = [], selectedProductId: string = "") {
        const product = this.GetSelectedProduct(products, selectedProductId);
        if (product && product.carbonSavings.savingsComparedToNonECOVariant > 0) {
            return product.carbonSavings;
        }
    }

    public CalculateVolumeSandBox(width?: number, length?: number, depth?: number) {
        if (width && length && depth) {
            return width * length * (depth / 100);
        }
    }

    public CalculateWeightFogSand(width?: number, length?: number, thickness?: number, jointwidth?: number, markyta?: number, fogSandFactor?: number) {
        if (markyta) {
            const consumptionPerArea = this.CalculateConsumptionPerAreaFogSand(width, length, thickness, jointwidth, fogSandFactor);
            if (consumptionPerArea) {
                return consumptionPerArea * markyta;
            }
        }
    }

    protected CalculateConsumptionPerAreaFogSand(width?: number, length?: number, thickness?: number, jointwidth?: number, fogSandFactor?: number) {
        if (width && length && thickness && jointwidth) {
            const weight = (((1 / (width + jointwidth)) + (1 / (length + jointwidth))) * jointwidth * thickness * 1.29);
            let weightParsed = parseFloat(weight.toFixed(2));
            if (weight - weightParsed !== 0) {
                weightParsed = weightParsed + 0.01;
            }
            return fogSandFactor && fogSandFactor !== 0 ? weightParsed * fogSandFactor : weightParsed;
        }
    }
}

export default new CalculatorService();
